'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useState } from 'react';

const Context = createContext({});
/**
 * DialogTriggerContext component, used to provide a context for a dialog trigger.
 *
 * @example
 * <Dialog.TriggerContext>
 *   <Dialog.Trigger>Open Dialog</Dialog.Trigger>
 *   <Dialog>
 *     Content
 *   </Dialog>
 * </Dialog.TriggerContext>
 */
const DialogTriggerContext = (rest) => {
    const [state, setState] = useState({});
    const setContext = (next) => setState({ ...state, ...next });
    return jsx(Context.Provider, { value: { ...state, setContext }, ...rest });
};
DialogTriggerContext.displayName = 'DialogTriggerContext';

export { Context, DialogTriggerContext };
